var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12451 22.1943C1.7085 22.1943 0.805176 21.3521 0.805176 20.1191C0.805176 18.7153 1.87939 17.5923 3.03906 16.5913C3.979 15.7734 4.1499 14.0034 4.40625 12.0747C4.73584 7.91211 6.16406 4.84814 9.19141 3.76172C9.75293 2.12598 11.1934 0.941895 13 0.941895C14.8066 0.941895 16.2349 2.12598 16.8086 3.76172C19.8359 4.84814 21.2642 7.91211 21.5938 12.0747C21.8379 14.0034 22.021 15.7734 22.9609 16.5913C24.1084 17.5923 25.1948 18.7153 25.1948 20.1191C25.1948 21.3521 24.2915 22.1943 22.8755 22.1943H3.12451ZM13 27.4556C10.6929 27.4556 9.0083 25.8564 8.86182 23.9644H17.1382C16.9917 25.8564 15.3071 27.4556 13 27.4556Z",
    fill: "#3C1460"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.fb6dc3caf978cf9ade56e427e0b8418c.svg";
export { ForwardRef as ReactComponent };